import {
  Component,
  ComponentInterface,
  EventEmitter,
  Event,
  h,
  State,
  Prop,
} from "@stencil/core";
import { IThemeOptions } from "../../../models";
import { ThemeService } from "../../../services";

@Component({
  tag: "av-card-header",
  styleUrl: "av-card-header.scss",
  shadow: true,
})
export class AvCardHeader implements ComponentInterface {
  @Prop() closeHidden: boolean;

  @Event({ bubbles: false }) close: EventEmitter;

  @State() themeOptions: IThemeOptions;

  constructor() {
    ThemeService.optionsAvailable().subscribe(
      (options) => (this.themeOptions = options)
    );
  }

  onClose() {
    this.close.emit(this);
  }

  render() {
    const cardHeaderStyle = {
      backgroundColor: this.themeOptions.colorAccent,
    };
    return (
      <div class="av-card-header" style={cardHeaderStyle}>
        <div class="av-card-header-title" role="heading">
          <slot></slot>
        </div>
        <div class="av-card-header-actions">
          <slot name="card-header-actions"></slot>
          {!this.closeHidden && (
            <av-button
              class="av-card-header-close"
              size="sm"
              shape="round"
              color="basic"
              onClick={this.onClose.bind(this)}
            >
              <av-asset image="close"></av-asset>
            </av-button>
            // <button
            //   class="av-card-header-close"
            //   onClick={this.onClose.bind(this)}
            // >
            //   <av-asset image="close"></av-asset>
            // </button>
          )}
        </div>
      </div>
    );
  }
}
